import { Platform } from 'react-native';
import { useColorScheme } from 'nativewind';

/** Semantic color tokens for use in JS (Ionicons, ActivityIndicator, tab bar config, etc.) */
export const colors = {
  light: {
    primary: '#2B7A50',       // forest-600
    primaryLight: '#EBF5EF',  // forest-50
    text: '#18190F',
    textSecondary: '#57584E',
    textTertiary: '#9A9B92',
    background: '#F4F3EF',    // canvas
    surface: '#ffffff',
    border: '#e5e7eb',
    borderLight: '#f3f4f6',
    error: '#dc2626',
    errorLight: '#fef2f2',
  },
  dark: {
    primary: '#22C55E',       // green-500, readable without feeling neon
    primaryLight: '#1F5237',  // forest-700
    text: '#F4F3EF',
    textSecondary: '#A8AAA0',
    textTertiary: '#6E746D',
    background: '#0F1411',    // canvas-dark
    surface: '#1f2937',
    border: '#374151',
    borderLight: '#1f2937',
    error: '#f87171',
    errorLight: '#450a0a',
  },
} as const;

/**
 * On web with `darkMode: 'class'`, NativeWind's JS hook can report 'dark'
 * (from system preference) while the CSS dark: classes are inactive (no
 * `.dark` on `<html>`). Check the DOM to stay in sync with the CSS.
 */
function useIsDark(): boolean {
  const { colorScheme } = useColorScheme();

  if (Platform.OS === 'web' && typeof document !== 'undefined') {
    return document.documentElement.classList.contains('dark');
  }

  return colorScheme === 'dark';
}

export function useColors() {
  const isDark = useIsDark();
  return isDark ? colors.dark : colors.light;
}
